import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';
import { toast } from 'react-toastify';
import CategoriesCard from '../components/CategoriesCard';
import Subscribe from '../components/Subscribe';
import { getError } from '../utils';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

// Typewriter component
function Typewriter({ textArray, speed = 100, pause = 2000 }) {
  const [text, setText] = useState('');
  const [loopIndex, setLoopIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    if (!textArray || textArray.length === 0) return;

    const current = textArray[loopIndex % textArray.length];

    if (charIndex < current.length) {
      const timeout = setTimeout(() => {
        setText((prev) => prev + current[charIndex]);
        setCharIndex((prev) => prev + 1);
      }, speed);
      return () => clearTimeout(timeout);
    } else {
      const timeout = setTimeout(() => {
        setText('');
        setCharIndex(0);
        setLoopIndex((prev) => prev + 1);
      }, pause);
      return () => clearTimeout(timeout);
    }
  }, [charIndex, loopIndex, textArray, speed, pause]);

  return <div className='typewriter-text'>{text}</div>;
}

export default function Home() {
  const [homeContent, setHomeContent] = useState({
    title: '',
    description: '',
    h4Text: [],
    jumbotronImages: [],
    jumbotronText: [],
  });

  useEffect(() => {
    const fetchHomeContent = async () => {
      try {
        const { data } = await axios.get('/api/homecontent');
        setHomeContent(
          data || {
            title: '',
            description: '',
            h4Text: [],
            jumbotronImages: [],
            jumbotronText: [],
          }
        );
      } catch (err) {
        toast.error(getError(err));
      }
    };
    fetchHomeContent();
  }, []);

  return (
    <>
      <div>
        <Helmet>
          <title>{homeContent.title || 'ExoticWoodPen'}</title>
          <meta
            name='description'
            content={
              homeContent.description ||
              'Bespoke artisan pens and wooden products.'
            }
          />
          <meta
            name='keywords'
            content='pens, woodwork, bespoke, artisan, handmade'
          />
        </Helmet>

        {/* Jumbotron Image Carousel */}
        {Array.isArray(homeContent.jumbotronImages) &&
          homeContent.jumbotronImages.length > 0 && (
            <Carousel
              showThumbs={false}
              showStatus={false}
              autoPlay
              infiniteLoop
              interval={10000}
              transitionTime={1000}
            >
              {homeContent.jumbotronImages.map((image, index) => (
                <div key={index} style={{ position: 'relative' }}>
                  <img src={image} alt={`Jumbotron ${index}`} />
                  {Array.isArray(homeContent.jumbotronText) &&
                    homeContent.jumbotronText.length > 0 && (
                      <div className='carousel-caption'>
                        <Typewriter textArray={homeContent.jumbotronText} />
                      </div>
                    )}
                </div>
              ))}
            </Carousel>
          )}
        <br />
        <div className='content'>
          <div className='box'>
            {homeContent && (
              <>
                {/* fountain pen unicode: &#x1F58B; */}
                <h2>&#x1F58B; {homeContent.title}</h2>
                <h4>
                  {homeContent.h4Text.map((text, index) => (
                    <span key={index} className='item'>
                      {text}
                    </span>
                  ))}
                </h4>
                <p>~ {homeContent.description} ~</p>
              </>
            )}
          </div>
        </div>

        <br />
        <CategoriesCard />

        <div className='parallax'></div>
        <br />
        <Subscribe />
      </div>

      <br />
    </>
  );
}
